const EVENTS = {
    onUpdate: 'tlh-animate-update',
    onStart: 'tlh-animate-start',
    onComplete: 'tlh-animate-complete',
    onStartReverse: 'tlh-animate-start-reverse',
    onCompleteReverse: 'tlh-animate-complete-reverse',
    onResize: 'tlh-animate-resize',
    globalScroll: 'tlh-global-scroll',
    globalResize: 'tlh-global-resize'
}

const ELEMENTS_CLASS = {
    marker: 'tlh-scroll-marker',
    markerStart: 'tlh-scroll-marker-start',
    markerEnd: 'tlh-scroll-marker-end',
    pinSpacer: 'tlh-pin-section',
    pinInner: 'tlh-pin-inner'
}

export { EVENTS, ELEMENTS_CLASS };